var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.7 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Range Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.82,36.16H7.55a1.63,1.63,0,0,1-1.62-1.63V20.89a1.63,1.63,0,0,1,1.62-1.63H30.82a1.63,1.63,0,0,1,1.63,1.63V34.53A1.63,1.63,0,0,1,30.82,36.16ZM7.55,20.51a.38.38,0,0,0-.37.38V34.53a.38.38,0,0,0,.37.38H30.82a.38.38,0,0,0,.38-.38V20.89a.38.38,0,0,0-.38-.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84.29H2.94A2.75,2.75,0,0,0,.19,3V45a2.75,2.75,0,0,0,2.75,2.75h32.9A2.75,2.75,0,0,0,38.59,45V3A2.75,2.75,0,0,0,35.84.29ZM2.94,1.79h32.9A1.25,1.25,0,0,1,37.09,3v7.27H1.69V3A1.25,1.25,0,0,1,2.94,1.79Zm34.15,10V39.59H1.69V11.81Zm-1.25,34.4H2.94A1.25,1.25,0,0,1,1.69,45V41.09h35.4V45A1.25,1.25,0,0,1,35.84,46.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,6.35H5.75a.5.5,0,0,1,0-1H9a.5.5,0,0,1,0,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.82,16.5H6.55a.63.63,0,0,1,0-1.25H31.82a.63.63,0,1,1,0,1.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15,6.35h-3.2a.5.5,0,0,1,0-1H15a.5.5,0,0,1,0,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21,6.35H17.78a.5.5,0,0,1,0-1H21a.5.5,0,0,1,0,1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27,6.35H23.8a.5.5,0,0,1,0-1H27a.5.5,0,0,1,0,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33,6.35h-3.2a.5.5,0,0,1,0-1H33a.5.5,0,0,1,0,1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36,30.42A.47.47,0,0,1,9,30.27a.5.5,0,0,1,0-.71l6.81-6.82a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L9.71,30.27A.47.47,0,0,1,9.36,30.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36,26A.46.46,0,0,1,9,25.86a.5.5,0,0,1,0-.71l2.8-2.81a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L9.71,25.86A.46.46,0,0,1,9.36,26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.2e3e8abe95db73b781cdc1624d67d9e9.svg";
export { ForwardRef as ReactComponent };